var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgValue = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 15
}, props), _text || (_text = /*#__PURE__*/React.createElement("text", {
  fill: "#aaa",
  fillRule: "evenodd",
  fontFamily: "SourceSansPro-Bold, Source Sans Pro",
  fontSize: 22,
  fontWeight: "bold",
  transform: "translate(-1 -7)"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 22
}, "\xA3"))));
export default SvgValue;